import { ridSegment } from '@krp/client-runtime'

/**
 * Адреса трассировки продаж (RP-SALE-TRACE) через Gateway; все — с правом кабинета `sales.trace`.
 * rid — сегмент пути каждого запроса (D-064).
 */
const resource = (resourceId: string) => `/api/aqsi/v1/resources/${ridSegment(resourceId)}`

export const AQSI_TRACE_URLS = {
  /** Точки браузера одной продажи (лёгкий режим). */
  browser: (resourceId: string) => `${resource(resourceId)}/trace/browser`,
  /** События браузера подробного режима. */
  browserDetail: (resourceId: string) => `${resource(resourceId)}/trace/browser/detail`,
  sales: (resourceId: string) => `${resource(resourceId)}/trace/sales`,
  sale: (resourceId: string, saleId: string) => `${resource(resourceId)}/trace/sales/${encodeURIComponent(saleId)}`,
  /** Тренд доставки «кабинет → касса» по часам; `?hours=` 1…72, по умолчанию сутки. */
  deliveryTrend: (resourceId: string) => `${resource(resourceId)}/trace/delivery-trend`,
  /** Подробный режим: прочитать и включить/выключить. */
  deep: (resourceId: string) => `${resource(resourceId)}/trace/deep`,
  /** Контрольный замер кассы: пять служебных чтений. */
  registerCheck: (resourceId: string) => `${resource(resourceId)}/trace/register-check`,
} as const
